import { Controller, useFormContext } from "react-hook-form";
import { DynDadosCadastraisProps } from "..";
import { useMemo, useState } from "react";
import { Button, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogAddEditDadoProcurador from "./DialogAddEditDadoProcurador";
import { Moment } from "moment";

export default function DadosProcuradores({ spec, extras }: DynDadosCadastraisProps) {

    const { control, watch, getValues, setValue } = useFormContext();

    const [openProcuradorModal, setOpenProcuradorModal] = useState<TOpenModalDadosProcuradores>({ open: false });

    const possuiProcurador = watch(`${spec.name}.possui_procurador`) === "Sim"
    const procuradores = watch(`${spec.name}.procuradores`) || [];
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 };

    const opcoesRadio = useMemo(() => [
        { value: "Sim", label: "Sim" },
        { value: "Não", label: "Não" },
    ], [])
    return (
        <>
            <Grid container size={{ xs: 12 }} spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Typography fontWeight={'bold'} variant="h6">Dados do Procurador</Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Controller
                        name={`${spec.name}.possui_procurador`}
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <FormControl {...field}>
                                <FormLabel id="possui_procurador">Possui procurador?</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="possui_procurador"
                                    value={getValues(`${spec.name}.possui_procurador`)}
                                    onChange={(e) => field.onChange(e.target.checked)}
                                >
                                    {
                                        opcoesRadio.map((opcao, index) => (
                                            <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                                        ))
                                    }
                                </RadioGroup>
                                <FormHelperText error>{error ? error.message : ""}</FormHelperText>
                            </FormControl>
                        )}
                    />
                </Grid>
                {
                    possuiProcurador && procuradores.length > 0 &&
                    <>
                        <Grid size={{ xs: 12 }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={paddingStyle}>
                                                <b>Nome/CNPJ</b>
                                            </TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {procuradores.map((item: IDadosProcuradores, index: number) => (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <Controller
                                                    name={`${spec.name}.sociedades[${index}]`}
                                                    control={control}
                                                    rules={{ required: "Campo obrigatório" }}
                                                    render={({ field, fieldState: { error, invalid } }) => (
                                                        <TableCell sx={{ ...paddingStyle, color: invalid ? 'red' : 'inherit' }}>
                                                            {item.nome || item.cpf} {invalid && "Campo obrigatório"}
                                                        </TableCell>
                                                    )}
                                                />
                                                <TableCell sx={paddingStyle}>
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="flex-end"
                                                    >
                                                        <IconButton
                                                            aria-label="edit"
                                                            onClick={() => {
                                                                setOpenProcuradorModal({ open: true, index });
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                const novosProcuradores = procuradores.filter((_: any, i: number) => i !== index);
                                                                setValue(`${spec.name}.procuradores`, novosProcuradores);
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </>
                }
                {
                    possuiProcurador &&
                    <Grid size={{ xs: 12 }}>
                        <Controller
                            name={`${spec.name}.procuradores`}
                            control={control}
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { error, invalid } }) => (
                                <>
                                    <Button
                                        variant="outlined"
                                        color={error ? 'error' : 'primary'}
                                        startIcon={<AddIcon />}
                                        onClick={() => setOpenProcuradorModal({ open: true })}
                                    >
                                        Adicionar Procurador
                                    </Button>
                                    <FormHelperText error>{invalid && error ? error.message : ""}</FormHelperText>
                                </>
                            )}
                        />

                    </Grid>
                }
            </Grid>
            {
                openProcuradorModal.open &&
                <DialogAddEditDadoProcurador
                    open={openProcuradorModal.open}
                    index={openProcuradorModal.index}
                    onClose={() => setOpenProcuradorModal({ open: false })}
                />
            }
        </>
    )
}

export interface IDadosProcuradores {
    nome: string;
    nome_social?: string;
    rg: string;
    cpf: string;
    sexo: string;
    data_nascimento: Moment | null;
    nacionalidade: string;
    nome_mae?: string;
    nome_pai?: string;
    grau_parentesco?: string;
    //Endereço
    cep?: string;
    endereco?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    uf?: string;
}

export type TOpenModalDadosProcuradores = {
    open: boolean;
    index?: number;
}

